import { render, staticRenderFns } from "./addAddress.vue?vue&type=template&id=3f547454&scoped=true"
import script from "./addAddress.vue?vue&type=script&lang=js"
export * from "./addAddress.vue?vue&type=script&lang=js"
import style0 from "./addAddress.vue?vue&type=style&index=0&id=3f547454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f547454",
  null
  
)

export default component.exports